import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import AxiosInstance from "../components/Axios";
import BorderColor from "@mui/icons-material/BorderColor";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./ToggleSwitch.css";
import ToggleSwitch from "./ToggleSwitch";
import {
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Accordion,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  tableCellClasses,
  styled,
  IconButton,
  Menu,
  Modal,
  Box,
  Drawer,
  Divider,
  Switch,
  Paper,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import Partners from "./Partners";
import colors from "../components/constants/Colors";
import VariableParamManager from "./VariableParamManager";
import {
  Close,
  ControlPoint,
  ExpandMore,
  Reorder,
  SettingsOutlined,
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// Styles pour le tableau
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.primary,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // Hide the last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// Ajoutez ce style personnalisé pour les accordéons
const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: "8px !important",
  marginBottom: "16px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  border: "1px solid rgba(0,0,0,0.08)",
  overflow: "hidden",

  "&:before": {
    display: "none",
  },

  "& .MuiAccordionSummary-root": {
    paddingLeft: 16,
    paddingRight: 16,
    backgroundColor: "#f8f8f8",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },

  "& .MuiAccordionDetails-root": {
    padding: "16px 16px 24px",
  },
}));

const Variable = () => {
  // États pour les métriques en ligne
  const [platformName, setPlatformName] = useState("");
  const [metricType, setMetricType] = useState("");
  const [reachedCountMetrics, setReachedCountMetrics] = useState(null);
  const [onlineMetrics, setOnlineMetrics] = useState([]);
  const [columnsMetrics, setColumnsMetrics] = useState([]);
  const [pageMetrics, setPageMetrics] = useState(0);
  const [rowsPerPageMetrics, setRowsPerPageMetrics] = useState(5);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [currentEditMetric, setCurrentEditMetric] = useState(null);

  // États pour les variables de paramètres
  const [variablesParams, setVariablesParams] = useState([]);
  const [selectNameParams, setSelectNameParams] = useState("");
  const [variableParamsValue, setVariableParamsValue] = useState("");

  // other states
  const [variables, setVariables] = useState([]);
  const [selectedName, setSelectedName] = useState("");
  const [variableValue, setVariableValue] = useState("");
  const [newValue, setNewValue] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [reachedCount, setReachedCount] = useState("");
  const [reachedCounts, setReachedCounts] = useState({});
  const [audiencePic, setAudiencePic] = useState([]);
  const [audienceName, setAudienceName] = useState("");
  const [addAudienceState, setAddAudienceState] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [valueOptions, setValueOptions] = useState([]);
  const [selectedVariable, setSelectedVariable] = useState();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 4,
  });

  const pic = localStorage.getItem("user_id");
  const [isDisabled, setisDisabled] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const [page, setPage] = useState({});
  const [rowsPerPage] = useState(6);
  const [rows, setRows] = useState([]);
  const [audiences, setAudiences] = useState([]);
  const [newAudience, setNewAudience] = useState({ audience: "", pic: "" });
  const [editId, setEditId] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [allVariableNames, setAllVariableNames] = useState([]);

  // Les anciennes listes statiques qui ne sont plus nécessaires (mais gardées pour référence)
  const metricsOptions = ["Likes", "Followers", "Visitors"];
  const socialMediaOptions = [
    "Facebook",
    "TikTok",
    "LinkedIn",
    "Instagram",
    "YouTube",
    "X",
    "Newsletter",
    "Website",
    "Platform",
    "Other social",
  ];
  const predefinedNames = [
    "Social Media",
    "Channels of communication",
    "Type of Activities",
    "Dissemination Activities",
    "Audiences",
    "Reporting Period",
    "Status",
    "Type of publication",
  ];

  // Handlers pour les métriques en ligne
  const openEditModal = (metricData) => {
    setCurrentEditMetric(metricData);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setCurrentEditMetric(null);
  };

  const handlePlatformNameChange = (e) => {
    setPlatformName(e.target.value);
  };

  const handleMetricTypeChange = (e) => {
    setMetricType(e.target.value);
  };

  const handleReachedCountMetricsChange = (e) => {
    setReachedCountMetrics(Number(e.target.value));
  };

  const handleMenuOpen = (event, metricId) => {
    setAnchorEl(event.currentTarget);
    setSelectedMetric(metricId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedMetric(null);
  };

  const handleEditMetric = (id) => {
    const metricData = onlineMetrics.find((metric) => metric.id === id);
    openEditModal(metricData);
    setAnchorEl(null);
  };

  const handleSaveMetric = async () => {
    closeEditModal();
    let hasInvalidValues = false;
    let invalidMetricName = "";

    for (const metric in currentEditMetric.metrics) {
      const reachedCount = currentEditMetric.metrics[metric]?.reached_count;

      // Vérifier si la valeur est vide, 0, ou non numérique
      if (
        reachedCount === "" ||
        reachedCount === "0" ||
        reachedCount === 0 ||
        isNaN(reachedCount)
      ) {
        hasInvalidValues = true;
        invalidMetricName = metric;
        break;
      }
    }

    if (hasInvalidValues) {
      // Afficher l'erreur mais ne pas fermer le modal
      Swal.fire({
        icon: "error",
        title: "Invalid Value",
        text: `The metric "${invalidMetricName}" cannot be empty or zero.`,
      });
      fetchMetrics();
      return; // Sortir de la fonction sans fermer le modal
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save these changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await AxiosInstance.put(
            `/metrics/${currentEditMetric.id}/update/`,
            currentEditMetric
          );

          const updatedMetrics = onlineMetrics.map((metric) =>
            metric.id === currentEditMetric.id ? currentEditMetric : metric
          );
          setOnlineMetrics(updatedMetrics);
          setAnchorEl(null);
          closeEditModal();

          await Swal.fire("Saved!", "Your changes have been saved.", "success");
        } catch (error) {
          console.error("Failed to update metric:", error);
          await Swal.fire(
            "Error!",
            "Failed to save the changes. Please try again.",
            "error"
          );
        }
      }
    });
  };

  const handleDelete = async (metricId) => {
    handleMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this metric!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await AxiosInstance.delete(
            `/metrics/${metricId}/delete/`
          );
          fetchMetrics();
          await Swal.fire(
            "Deleted!",
            "Your metric has been deleted.",
            "success"
          );
        } catch (error) {
          console.error(
            "Error deleting metric:",
            error.response?.data || error.message
          );
          await Swal.fire(
            "Error!",
            "There was a problem deleting the metric.",
            "error"
          );
        }
      }
    });
  };

  const handleChangePageMetrics = (event, newPage) => {
    setPageMetrics(newPage);
  };

  const handleChangeRowsPerPageMetrics = (event) => {
    setRowsPerPageMetrics(+event.target.value);
    setPageMetrics(0);
  };

  // Fonctions pour récupérer les données
  useEffect(() => {
    fetchMetrics();
  }, [project_id]);

  // Chargement des variables de paramètres depuis l'API
  useEffect(() => {
    const fetchVariables = async () => {
      try {
        const response = await AxiosInstance.get(
          `projects/${project_id}/param-variables/`
        );
        setVariablesParams(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des variables:", error);
      }
    };

    fetchVariables();
  }, [project_id]);

  // Fonction pour récupérer les options de valeurs
  const getOptions = (name) => {
    const variable = variablesParams.find((v) => v.name === name);
    return variable ? variable.values.map((v) => v.value) : [];
  };

  const fetchMetrics = async () => {
    try {
      const response = await AxiosInstance.get(
        `/projects/${project_id}/metrics`
      );

      if (response.data && response.data.length > 0) {
        setOnlineMetrics(response.data);

        const allMetrics = response.data.reduce((acc, metricData) => {
          Object.keys(metricData.metrics).forEach((metric) => {
            if (!acc.includes(metric)) acc.push(metric);
          });
          return acc;
        }, []);

        setColumnsMetrics(allMetrics);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des métriques en ligne :",
        error
      );
    }
  };

  const createPlatform = () => {
    if (!platformName || !metricType || reachedCountMetrics <= 0) {
      alert("Please fill in all fields!");
      return;
    }

    const platformData = {
      platform: platformName,
      metrics: {
        [metricType]: { reached_count: reachedCountMetrics },
      },
    };

    AxiosInstance.post(`projects/${project_id}/metrics/create/`, platformData)
      .then((response) => {
        fetchMetrics();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `The platform "${platformName}" with metric "${metricType}" was created successfully!`,
          confirmButtonText: "OK",
        });
      })
      .catch((error) => {
        console.error(
          "Error creating platform:",
          error.response ? error.response.data : error.message
        );
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.error ||
            "An unexpected error occurred. Please try again.",
        });
      });
    setPlatformName("");
    setMetricType("");
    setReachedCountMetrics("");
  };

  // Fonctions pour les variables
  const Getproject = async () => {
    try {
      const response = await axios.get(
        `https://eutracker.rdiup.com/v1/project/${project_id}/`
      );
      setIsSocial(response.data.isSocial);
    } catch (error) {
      console.error("Error fetching project:", error);
    }
  };

  useEffect(() => {
    Getproject();

    // Fetch audiences
    AxiosInstance.get("/projects/audiences/")
      .then((response) => {
        setAudiencePic(response.data.map((a) => a.audience));
      })
      .catch((error) => console.error("Failed to fetch audiences:", error));

    // Fetch variables
    AxiosInstance.get(`projects/${project_id}/variables/`)
      .then((response) => {
        setVariables(response.data);
        setValueOptions(response.data);

        // Récupérer tous les noms de variables uniques
        const uniqueNames = [
          ...new Set(response.data.map((variable) => variable.name)),
        ];

        setAllVariableNames(uniqueNames);

        const transformedRows = response.data.flatMap((variable) =>
          variable.values.map((value) => ({
            id: `${variable.id}-${value.value}`,
            variableId: variable.id,
            name: variable.name,
            value: value.name,
            reachedCount: value.reached_counts,
          }))
        );

        setRows(transformedRows);

        const initialPageState = uniqueNames.reduce((acc, name) => {
          acc[name] = 0;
          return acc;
        }, {});
        setPage(initialPageState);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleEditClick = (id) => () => {
    const selectedRow = rows.find((row) => row.id === id);
    const selectedVariable = variables.find(
      (variable) => variable.id === selectedRow.variableId
    );

    setSelectedRow(selectedRow);
    setSelectedVariable(selectedVariable);
    setNewValue(selectedRow.value);
    setReachedCounts(selectedRow.reachedCount);
    setReachedCount(selectedRow.reachedCount[project_id]);
    setOpenDialog(true);
  };

  const handleSaveClick = async () => {
    if (
      reachedCount !== "" &&
      reachedCount !== null &&
      reachedCount !== undefined
    ) {
      reachedCounts[project_id] = Number(reachedCount);
    }
    const valuesPayload = {
      id: selectedVariable.valueId,
      name: newValue || null,
      ...(Object.keys(reachedCounts).length > 0 && {
        reached_counts: reachedCounts,
      }),
    };

    try {
      const payload = {
        name: selectedVariable.name,
        values: [valuesPayload],
      };

      const response = await axios.put(
        `https://eutracker.rdiup.com/v1/projects/${project_id}/variables/update/${selectedVariable.id}/`,
        payload
      );

      window.location.reload();
      handleCloseDialog();
    } catch (error) {
      const errorMessage = error.response?.data || error.message;
      console.error("Failed to save changes:", errorMessage);
      handleCloseDialog();

      Swal.fire(
        "Error",
        Array.isArray(errorMessage) ? errorMessage[0] : errorMessage,
        "error"
      );
    }
  };

  const createAudience = () => {
    AxiosInstance.post("/projects/audiences/create", {
      audience: audienceName,
      pic,
    })
      .then((response) => {
        setAudiences([...audiences, response.data]);
        setAudienceName("");
        Swal.fire({
          icon: "success",
          title: "Audience created",
          text: "The audience has been created successfully.",
        });
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.audience?.[0] ||
          "An error occurred while creating the audience.";

        Swal.fire({
          icon: "error",
          title: "Failed to create audience",
          text:
            errorMessage === "audiences with this audience already exists."
              ? "this audience is already exists"
              : errorMessage,
        });

        console.error("Failed to create audience:", error);
      });
  };

  const loadDefaultVariables = async (projectId) => {
    try {
      const response = await AxiosInstance.post(
        `/projects/${projectId}/load-defaults/`
      );
      console.log("Defaults loaded:", response.data);
      // You can update local state with response.data if needed
    } catch (error) {
      console.error("Error loading default variables:", error);
    }
  };
  const [defaultsLoaded, setDefaultsLoaded] = useState(false);

  /* useEffect(() => {
    if (project_id && !defaultsLoaded) {
      loadDefaultVariables(project_id);
      setDefaultsLoaded(true);
      console.log("All params loaded defaults — existing.");
    } else if (!project_id) {
      console.log("No need to load defaults — already done on create.");
    }
  }, [project_id, defaultsLoaded]); */

  const handleDeleteClick = (id) => () => {
    const rowToDelete = rows.find((row) => row.id === id);
    const updatedVariable = variables.find(
      (variable) => variable.id === rowToDelete.variableId
    );

    Swal.fire({
      title: "Are you sure you want to delete?",
      text: "This action is irreversible.",
      icon: "warning",
      iconColor: colors.primary,
      showCancelButton: true,
      confirmButtonText: "Yes, delete!",
      confirmButtonColor: colors.primary,
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedValues = updatedVariable.values.filter(
          (value) => value.id !== rowToDelete.valueId
        );

        AxiosInstance.delete(
          `projects/${project_id}/variables/delete/${updatedVariable.id}/`,
          { values: updatedValues }
        )
          .then((response) => {
            const updatedVariables = variables.map((variable) =>
              variable.id === response.data.id ? response.data : variable
            );
            setVariables(updatedVariables);
            setRows(rows.filter((row) => row.id !== id));
          })
          .catch((error) => console.error(error));
      }
    });
  };

  const columns = [
    { field: "value", headerName: "Value", width: 200, editable: true },
    {
      field: "reachedCount",
      headerName: "Count",
      width: 180,
      editable: true,
      renderCell: (params) => {
        const count =
          params.value &&
          typeof params.value === "object" &&
          project_id in params.value
            ? params.value[project_id]
            : null;

        return <span>{count === null || count === "" ? "N/A" : count}</span>;
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            key="edit"
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            key="delete"
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewValue("");
  };

  // 1ème code
  // const renderTable = (name) => {

  //   //   Ne pas afficher la table Social Media si isSocial est false
  // //   if (name === "Social Media" && isSocial === false) {
  // //     return null;
  // //   }

  //   const filteredRows = rows.filter((row) => row.name === name);

  //   // Tri pour Reporting Period
  //   if (name === "Reporting Period") {
  //     filteredRows.sort((a, b) => a.value.localeCompare(b.value));
  //   }

  //   return (
  //     // Supprimer le Grid item xs={12} md={6} ici pour éviter la double imbrication
  //     <Box
  //       sx={{
  //         borderRadius: '8px',
  //         overflow: 'hidden',
  //         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  //         backgroundColor: '#fff',
  //         height: '100%',
  //         display: 'flex',
  //         flexDirection: 'column',
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           backgroundColor: colors.primary,
  //           p: 1.5,
  //           display: 'flex',
  //           justifyContent: 'space-between',
  //           alignItems: 'center',
  //         }}
  //       >
  //         <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 500 }}>
  //           {name}
  //         </Typography>
  //       </Box>
  //       <Box sx={{ flexGrow: 1, overflow: 'auto', maxHeight: '350px' }}>
  //         <TableContainer component={Paper} sx={{ boxShadow: 'none', height: '100%' }}>
  //           <Table stickyHeader size="small">
  //             <TableHead>
  //               <TableRow>
  //                 <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>Value</TableCell>
  //                 <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>Count</TableCell>
  //                 <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5', width: '100px' }}>Actions</TableCell>
  //               </TableRow>
  //             </TableHead>
  //             <TableBody>
  //               {filteredRows.length > 0 ? (
  //                 filteredRows.map((row) => (
  //                   <TableRow
  //                     key={row.id}
  //                     sx={{
  //                       '&:hover': {
  //                         backgroundColor: 'rgba(0, 0, 0, 0.04)',
  //                       },
  //                     }}
  //                   >
  //                     <TableCell>{row.value}</TableCell>
  //                     <TableCell>
  //                       {row.reachedCount &&
  //                       typeof row.reachedCount === "object" &&
  //                       project_id in row.reachedCount
  //                         ? row.reachedCount[project_id]
  //                         : "N/A"}
  //                     </TableCell>
  //                     <TableCell>
  //                       <Box sx={{ display: 'flex', gap: 1 }}>
  //                         <IconButton
  //                           size="small"
  //                           onClick={() => handleEditClick(row.id)()}
  //                           sx={{
  //                             color: colors.primary,
  //                             '&:hover': { backgroundColor: 'rgba(63, 81, 181, 0.08)' }
  //                           }}
  //                         >
  //                           <EditIcon fontSize="small" />
  //                         </IconButton>
  //                         <IconButton
  //                           size="small"
  //                           onClick={() => handleDeleteClick(row.id)()}
  //                           sx={{
  //                             color: '#d32f2f',
  //                             '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.08)' }
  //                           }}
  //                         >
  //                           <DeleteIcon fontSize="small" />
  //                         </IconButton>
  //                       </Box>
  //                     </TableCell>
  //                   </TableRow>
  //                 ))
  //               ) : (
  //                 <TableRow>
  //                   <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
  //                     <Typography variant="body2" color="text.secondary">
  //                       No data available
  //                     </Typography>
  //                   </TableCell>
  //                 </TableRow>
  //               )}
  //             </TableBody>
  //           </Table>
  //         </TableContainer>
  //       </Box>
  //       {filteredRows.length > 5 && (
  //         <Box sx={{ p: 1, borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
  //           <TablePagination
  //             component="div"
  //             count={filteredRows.length}
  //             page={page[name] || 0}
  //             onPageChange={(e, newPage) => {
  //               setPage({ ...page, [name]: newPage });
  //             }}
  //             rowsPerPage={5}
  //             rowsPerPageOptions={[5, 10, 25]}
  //             sx={{
  //               '.MuiTablePagination-toolbar': {
  //                 minHeight: '48px',
  //               },
  //               '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
  //                 margin: 0,
  //               },
  //             }}
  //           />
  //         </Box>
  //       )}
  //     </Box>
  //   );
  // };

  //2ème code
  const renderTable = (name) => {
    // Ne pas afficher la table Social Media si isSocial est false
    // if (name === "Social Media" && isSocial === false) {
    //   return null;
    // }

    const filteredRows = rows.filter((row) => row.name === name);

    //Tri pour Reporting Period
    if (name === "Reporting Period") {
      filteredRows.sort((a, b) => a.value.localeCompare(b.value));
    }

    // Calculer les lignes à afficher selon la pagination
    const currentPage = page[name] || 0;
    const rowsPerPage = 5;
    const paginatedRows = filteredRows.slice(
      currentPage * rowsPerPage,
      currentPage * rowsPerPage + rowsPerPage
    );

    return (
      <Box
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            backgroundColor: colors.primary,
            p: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ color: "white", fontWeight: 500 }}
          >
            {name}
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, overflow: "auto", maxHeight: "350px" }}>
          <TableContainer
            component={Paper}
            sx={{ boxShadow: "none", height: "100%" }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      backgroundColor: "#f5f5f5",
                      width: "350px",
                      maxWidth: "350px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Value
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                  >
                    Count
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      backgroundColor: "#f5f5f5",
                      width: "100px",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedRows.length > 0 ? (
                  paginatedRows.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <TableCell>{row.value}</TableCell>
                      <TableCell>
                        {row.reachedCount &&
                        typeof row.reachedCount === "object" &&
                        project_id in row.reachedCount
                          ? row.reachedCount[project_id]
                          : "N/A"}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <IconButton
                            size="small"
                            onClick={() => handleEditClick(row.id)()}
                            sx={{
                              color: colors.primary,
                              "&:hover": {
                                backgroundColor: "rgba(63, 81, 181, 0.08)",
                              },
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteClick(row.id)()}
                            sx={{
                              color: "#d32f2f",
                              "&:hover": {
                                backgroundColor: "rgba(211, 47, 47, 0.08)",
                              },
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                      <Typography variant="body2" color="text.secondary">
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {filteredRows.length > rowsPerPage && (
          <Box sx={{ p: 1, borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
            <TablePagination
              component="div"
              count={filteredRows.length}
              page={page[name] || 0}
              onPageChange={(e, newPage) => {
                setPage((prev) => ({ ...prev, [name]: newPage }));
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5]}
              onRowsPerPageChange={null}
              sx={{
                ".MuiTablePagination-toolbar": {
                  minHeight: "48px",
                  paddingLeft: "0px", // Réduire l'espace à gauche
                },
                ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                  {
                    margin: 0,
                  },
                ".MuiTablePagination-select": {
                  display: "none", // Cacher le sélecteur de nombre de lignes par page
                },
                ".MuiTablePagination-selectLabel": {
                  display: "none", // Cacher le label "Rows per page"
                },
              }}
            />
          </Box>
        )}
      </Box>
    );
  };

  const add = async () => {
    try {
      const payload = {
        name: selectNameParams,
        values: [
          {
            name: variableParamsValue,
            reached_counts: reachedCount ? parseInt(reachedCount, 10) : null,
          },
        ],
        project: project_id,
      };

      const response = await axios.post(
        `https://eutracker.rdiup.com/v1/projects/${project_id}/variables/create/`,
        payload
      );
      Swal.fire("Success", "Variable created successfully!", "success");
      window.location.reload();
    } catch (error) {
      Swal.fire("Error", "something wrong !", "error");
      console.log("err", error);
    }
  };

  const handleCheckboxChange = async (e) => {
    const updatedValue = e.target.checked;
    setIsSocial(updatedValue);
    const porjectID = Number(project_id);

    try {
      await axios.patch(
        `https://eutracker.rdiup.com/v1/projects/${porjectID}/update_is_social/`,
        {
          isSocial: updatedValue,
        }
      );
      console.log("isSocial updated successfully");
    } catch (error) {
      console.error("Error updating isSocial:", error);
      setIsSocial(!updatedValue);
    }
  };

  const renderAudienceForm = () => {
    return (
      <Grid container>
        <Grid>
          <div style={{ textAlign: "left" }}>
            <span>Audience</span>
          </div>
          <FormControl fullWidth>
            <TextField
              fullWidth
              value={audienceName}
              onChange={(e) => setAudienceName(e.target.value)}
              sx={{ width: 250, height: 40 }}
              size="small"
            />
          </FormControl>
        </Grid>

        <Grid>
          <Button
            disabled={audienceName === ""}
            variant="contained"
            sx={{ backgroundColor: colors.secondary }}
            fullWidth
            style={{ marginLeft: 10, marginTop: 27, marginBottom: 0 }}
            onClick={createAudience}
          >
            Create Audience
          </Button>
        </Grid>
      </Grid>
    );
  };

  const renderFormsPlatform = () => {
    return (
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
              Platform name
            </Typography>
            <Select
              labelId="platform-select-label"
              value={platformName}
              onChange={handlePlatformNameChange}
              size="small"
            >
              {socialMediaOptions.map((platform, index) => (
                <MenuItem key={index} value={platform}>
                  {platform}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
              Metrics
            </Typography>
            <Select
              disabled={!platformName}
              value={metricType}
              onChange={handleMetricTypeChange}
              size="small"
            >
              {metricsOptions.map((metric, index) => (
                <MenuItem key={index} value={metric}>
                  {metric}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {metricType && (
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
                Reach count
              </Typography>
              <TextField
                fullWidth
                type="number"
                value={reachedCountMetrics}
                onChange={handleReachedCountMetricsChange}
                size="small"
              />
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={4}>
          <Button
            disabled={!metricType}
            variant="contained"
            fullWidth
            onClick={createPlatform}
            sx={{ marginTop: 3, backgroundColor: colors.secondary }}
          >
            Create Platform
          </Button>
        </Grid>
      </Grid>
    );
  };
  return (
    <Grid container sx={{ width: "100%", margin: 0, padding: 0 }}>
      {/* Drawer pour configurations avancées */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          sx: {
            width: { xs: "90%", sm: "950px" },
            p: 0,
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" fontWeight="600">
              Advanced Configurations
            </Typography>
            <IconButton onClick={() => setOpenDrawer(false)} size="small">
              <Close fontSize="small" />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 3 }} />
          <VariableParamManager projectId={project_id} />
        </Box>
      </Drawer>

      {/* Header controls */}
      <Grid
        container
        sx={{ mb: 3, mt: 1 }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm="auto">
          <Typography
            variant="h5"
            fontWeight="500"
            color={colors.secondary}
          ></Typography>
        </Grid>

        <Grid item xs={12} sm="auto" sx={{ mr: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            sx={{ mt: { xs: 2, sm: 0 } }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{ mr: 1, fontStyle: "italic" }}>
                Social activity project
              </Typography>
              <Switch
                checked={isSocial}
                onChange={handleCheckboxChange}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: colors.primary,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: colors.primary,
                  },
                }}
              />
            </Box>

            <Button
              variant="outlined"
              startIcon={<SettingsOutlined />}
              onClick={() => setOpenDrawer(true)}
              sx={{
                color: colors.primary,
                borderColor: colors.primary,
                "&:hover": {
                  borderColor: colors.primary,
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Advanced Configurations
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Edit Metrics Modal */}
      <Dialog
        open={isEditModalOpen}
        onClose={closeEditModal}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontWeight="600">
              Edit Metrics
            </Typography>
            <IconButton onClick={closeEditModal} size="small">
              <Close fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Edit metrics for{" "}
            <Box component="span" fontWeight="500" color={colors.primary}>
              {currentEditMetric?.platform}
            </Box>
          </DialogContentText>

          <Grid container spacing={2}>
            {currentEditMetric &&
              columnsMetrics.map((metric, index) => (
                <Grid item xs={12} sm={6} md={4} key={metric}>
                  <Typography variant="body2" fontWeight="500" sx={{ mb: 0.5 }}>
                    {metric}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    variant="outlined"
                    value={
                      currentEditMetric.metrics[metric]?.reached_count || ""
                    }
                    onChange={(e) => {
                      const updatedMetrics = { ...currentEditMetric.metrics };
                      if (!updatedMetrics[metric]) updatedMetrics[metric] = {};
                      updatedMetrics[metric].reached_count = e.target.value;
                      setCurrentEditMetric((prev) => ({
                        ...prev,
                        metrics: updatedMetrics,
                      }));
                    }}
                  />
                </Grid>
              ))}
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 1 }}
          >
            <Button variant="outlined" onClick={closeEditModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveMetric}
              sx={{ backgroundColor: colors.primary }}
            >
              Save Changes
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <AccordionDetails sx={{ width: "100%" }}>
        {/* Define Online Metrics Section */}
        <Box sx={{ mb: 3, width: "100%" }}>
          <Accordion
            defaultExpanded
            sx={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              borderRadius: "8px !important",
              "&:before": { display: "none" },
              width: "100%",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: colors.primary }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                borderBottom: "1px solid rgba(0,0,0,0.08)",
                "&.Mui-expanded": {
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                },
                width: "100%",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <BorderColor fontSize="small" sx={{ color: colors.primary }} />
                <Typography fontWeight={600} color={colors.secondary}>
                  Define Online Metrics
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 3, width: "100%" }}>
              {renderFormsPlatform()}
              <Box sx={{ mt: 3, width: "100%" }}>
                <TableContainer
                  sx={{
                    borderRadius: "8px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                    width: "100%",
                  }}
                >
                  <Table sx={{ width: "100%" }}>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Platform</StyledTableCell>
                        {columnsMetrics.map((metric, index) => (
                          <StyledTableCell key={index}>
                            {metric}
                          </StyledTableCell>
                        ))}
                        <StyledTableCell align="center">
                          Actions
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {onlineMetrics
                        .slice(
                          pageMetrics * rowsPerPageMetrics,
                          (pageMetrics + 1) * rowsPerPageMetrics
                        )
                        .map((metricData, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell>
                              <Typography fontWeight="500">
                                {metricData.platform}
                              </Typography>
                            </StyledTableCell>
                            {columnsMetrics.map((metric, index) => (
                              <StyledTableCell key={index}>
                                {metricData.metrics[metric]
                                  ? metricData.metrics[metric].reached_count
                                  : "N/A"}
                              </StyledTableCell>
                            ))}
                            <StyledTableCell align="center">
                              <IconButton
                                onClick={(event) =>
                                  handleMenuOpen(event, metricData.id)
                                }
                                size="small"
                                sx={{ color: colors.secondary }}
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  component="div"
                  count={onlineMetrics.length}
                  rowsPerPage={rowsPerPageMetrics}
                  page={pageMetrics}
                  onPageChange={handleChangePageMetrics}
                  onRowsPerPageChange={handleChangeRowsPerPageMetrics}
                  rowsPerPageOptions={[5, 10, 25]}
                  sx={{ mt: 1 }}
                />

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: {
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() =>
                      selectedMetric && handleEditMetric(selectedMetric)
                    }
                  >
                    Edit
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      selectedMetric && handleDelete(selectedMetric)
                    }
                  >
                    Delete
                  </MenuItem>
                </Menu>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

        {/* Define Variables Section */}
        <Box sx={{ mb: 3, width: "100%" }}>
          <Accordion
            defaultExpanded
            sx={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              borderRadius: "8px !important",
              "&:before": { display: "none" },
              width: "100%",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: colors.primary }} />}
              aria-controls="panel2-content"
              id="panel2-header"
              sx={{
                borderBottom: "1px solid rgba(0,0,0,0.08)",
                "&.Mui-expanded": {
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                },
                width: "100%",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <BorderColor fontSize="small" sx={{ color: colors.primary }} />
                <Typography fontWeight={600} color={colors.secondary}>
                  Define Variables
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 3, width: "100%" }}>
              <Grid container spacing={3} alignItems="flex-end">
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
                      Type
                    </Typography>
                    <Select
                      value={selectNameParams}
                      onChange={(e) => setSelectNameParams(e.target.value)}
                      size="small"
                      displayEmpty
                      renderValue={
                        selectNameParams
                          ? undefined
                          : () => "Select variable type"
                      }
                    >
                      <MenuItem value="" disabled>
                        Select variable type
                      </MenuItem>
                      {variablesParams.map((variable) => (
                        <MenuItem key={variable.id} value={variable.name}>
                          {variable.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
                      Value
                    </Typography>
                    <Select
                      value={variableParamsValue}
                      onChange={(e) => setVariableParamsValue(e.target.value)}
                      size="small"
                      disabled={!selectNameParams}
                      displayEmpty
                      renderValue={
                        variableParamsValue
                          ? undefined
                          : () =>
                              selectNameParams
                                ? "Select a value"
                                : "Select type first"
                      }
                    >
                      <MenuItem value="" disabled>
                        {selectNameParams
                          ? "Select a value"
                          : "Select type first"}
                      </MenuItem>
                      {selectNameParams &&
                        getOptions(selectNameParams).map((option, index) => (
                          <MenuItem key={index} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>

                {selectNameParams !== "Reporting Period" &&
                  selectNameParams !== "Social Media" &&
                  selectNameParams !== "Status" &&
                  selectNameParams !== "Participations" && (
                    <Grid item xs={12} sm={6} md={3}>
                      <FormControl fullWidth>
                        <Typography
                          variant="body2"
                          fontWeight="500"
                          sx={{ mb: 1 }}
                        >
                          Reach count
                        </Typography>
                        <TextField
                          type="number"
                          value={reachedCount}
                          onChange={(e) => setReachedCount(e.target.value)}
                          size="small"
                          fullWidth
                        />
                      </FormControl>
                    </Grid>
                  )}

                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    variant="contained"
                    onClick={add}
                    disabled={
                      selectNameParams === "" || variableParamsValue === ""
                    }
                    fullWidth
                    sx={{
                      backgroundColor: colors.secondary,
                      "&:hover": { backgroundColor: colors.secondary },
                      height: "40px",
                    }}
                    // startIcon={<AddIcon  />}
                  >
                    Add Variable
                  </Button>
                </Grid>
              </Grid>

              <Box sx={{ mt: 4, width: "100%" }}>
                <Grid container spacing={2}>
                  {allVariableNames.map((name, index) => (
                    <Grid item xs={12} md={6} key={name}>
                      <Box sx={{ height: "400px" }}>
                        {" "}
                        {/* Hauteur fixe pour toutes les tables */}
                        {renderTable(name)}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </AccordionDetails>

      {/* Edit Value Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
            maxWidth: "450px",
            width: "100%",
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontWeight="600">
              Edit Value
            </Typography>
            <IconButton onClick={handleCloseDialog} size="small">
              <Close fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Currently editing:{" "}
            <Box component="span" fontWeight="500" color={colors.primary}>
              {selectedVariable?.name}
            </Box>
          </DialogContentText>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
              Value
            </Typography>
            <Select
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              fullWidth
              size="small"
            >
              {getOptions(selectedVariable?.name).map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedVariable?.name !== "Reporting Period" &&
            selectedVariable?.name !== "Participations" &&
            selectedVariable?.name !== "Status" &&
            selectedVariable?.name !== "Social Media" && (
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight="500" sx={{ mb: 1 }}>
                  Reached Count
                </Typography>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  value={reachedCount != null ? reachedCount : ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setReachedCount(value !== "" ? value : null);
                  }}
                />
              </FormControl>
            )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button variant="outlined" onClick={handleCloseDialog}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveClick}
            sx={{ backgroundColor: colors.secondary }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
export default Variable;
